var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMusicFestivalNotAllowed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.922 2.147a.25.25 0 0 1 .328.237v10.152A4.73 4.73 0 0 0 17 11.25a4.74 4.74 0 0 0-3.792 1.888l.082.082.994.994a3.25 3.25 0 1 1 4.502 4.502l1.076 1.076a4.74 4.74 0 0 0 1.888-3.75V2.383a1.75 1.75 0 0 0-2.3-1.661l-10 3.308a1.75 1.75 0 0 0-1.2 1.661V8.18l1.5 1.5V5.692a.25.25 0 0 1 .171-.237l10-3.308zM9.75 11.8l-1.5-1.5v5.236a4.75 4.75 0 1 0 1.5 3.467zm8.719 8.719-1.275-1.275a3.25 3.25 0 0 1-3.438-3.438l-.516-.516-.759-.759a4.75 4.75 0 0 0 5.987 5.987zM8.25 19a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23.78 22.77a.8.8 0 0 1-.53.22.64.64 0 0 1-.35-.1.6.6 0 0 1-.18-.12l-8.48-8.48-13-13a1 1 0 0 1-.13-.17.75.75 0 0 1 1.18-.9l12 12 9.54 9.54a.75.75 0 0 1-.05 1.01"
})));
export default SvgMusicFestivalNotAllowed;